import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home';
import { LgpdComponent } from './components/lgpd/lgpd';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'lgpd', component: LgpdComponent }
];
